import { render, staticRenderFns } from "./OrgnizationIcon.vue?vue&type=template&id=55c4d9bf&"
import script from "./OrgnizationIcon.vue?vue&type=script&lang=js&"
export * from "./OrgnizationIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports